// @flow
import * as React from 'react';
import {
  ClientFilter,
  DataGrid,
  ListPageWrapper,
  PageTitle,
  useClients,
  useMissedAppsTagId,
  useSessionStorageState,
} from '../../shared';
import StatusFilter from '../../features/status-filter';
import { Box } from '@mui/material';
import { environment } from '../../../environments/environment';
import { clientColumns, TableSettings, useTableSettings, withTableSettings } from '../../features';
import { ClientViewSortInput, Field, PageInput, SortDirection } from '@coverright/data-access/types/enrollment';

const Page = () => {
  const missingAppsTagId = useMissedAppsTagId();
  const storeKey = 'missingApps'
  const [filters, setFilters] = useFilters(storeKey);
  const {columns} = useTableSettings(clientColumns, filters, settings => setFilters(settings.filters || {tags: [missingAppsTagId]}));
  const [page, setPage] = usePage(storeKey);
  const [sort, setSort] = useSort(storeKey);
  const {clients, loading, total} = useClients(page, filters, sort);

  return (
    <ListPageWrapper>
      <PageTitle title={'Missed Apps - CSR Follow Up'}>
        <TableSettings />

        <Box sx={{minWidth: 300}}>
          <StatusFilter value={filters?.status || ''}
                        onChange={value => (
                          setFilters(p => ({...p, status: value || undefined}))
                        )} />
        </Box>
      </PageTitle>

      <DataGrid columns={columns}
                page={page.page}
                rowsPerPage={page.size}
                total={total}
                loading={loading}
                rowsPerPageOptions={[50, 100, 200]}
                sort={sort}
                onSortModelChange={setSort}
                onPageChange={p => setPage(prev => ({...prev, page: p }))}
                onRowsPerPageChange={p => setPage(prev => ({...prev, size: p }))}
                rows={clients}/>
    </ListPageWrapper>
  );
};

export const MissingAppts = withTableSettings(Page, 'missingApps')

const useFilters = (storeKey: string) => {
  const missingAppsTagId = useMissedAppsTagId();
  return useSessionStorageState<ClientFilter>(
    storeKey + 'Filters',
    {tags: [missingAppsTagId]}
  );
};

const usePage = (storeKey: string) => {
  return useSessionStorageState<PageInput>(
    storeKey + 'Page',
    { page: 0, size: 100 }
  );
};

const useSort = (storeKey: string) => {
  return useSessionStorageState<ClientViewSortInput | undefined>(
    storeKey + 'Sort',
    {field: Field.CreatedAt, direction: SortDirection.Desc}
  )
}
